import createIcon from "./createIcon";

export const AspectRatioIcon = createIcon('AspectRatio', (props) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <defs>
        <filter id="pixso_custom_mask_type_alpha">
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0 " />
        </filter>
      </defs>
      <mask id="mask_0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse">
        <g filter="url(#pixso_custom_mask_type_alpha)">
          <g id="master_svg0_1903_0598">
            <rect width="24" height="24" x="0" y="0" fill="currentColor" />
          </g>
        </g>
      </mask>
      <rect id="1：1" width="24" height="24" x="0" y="0" />
      <g id="clip path group" mask="url(#mask_0)">
        <g>
          <g>
            <path d="M4 6L20 6L20 4L4 4L4 6ZM20 6C20.5523 6 21 6.44772 21 7L23 7C23 5.34315 21.6569 4 20 4L20 6ZM21 7L21 17L23 17L23 7L21 7ZM21 17C21 17.5523 20.5523 18 20 18L20 20C21.6569 20 23 18.6569 23 17L21 17ZM20 18L4 18L4 20L20 20L20 18ZM4 18C3.44772 18 3 17.5523 3 17L1 17C1 18.6569 2.34315 20 4 20L4 18ZM3 17L3 7L1 7L1 17L3 17ZM3 7C3 6.44772 3.44772 6 4 6L4 4C2.34315 4 1 5.34315 1 7L3 7Z" fill="currentColor" fillRule="nonzero" />
          </g>
          <g>
            <path d="M12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12L12 10ZM12.01 12C12.5623 12 13.01 11.5523 13.01 11C13.01 10.4477 12.5623 10 12.01 10L12.01 12ZM12 12L12.01 12L12.01 10L12 10L12 12Z" fill="currentColor" fillRule="nonzero" />
          </g>
          <g>
            <path d="M12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15L12 13ZM12.01 15C12.5623 15 13.01 14.5523 13.01 14C13.01 13.4477 12.5623 13 12.01 13L12.01 15ZM12 15L12.01 15L12.01 13L12 13L12 15Z" fill="currentColor" fillRule="nonzero" />
          </g>
          <g>
            <path d="M5.35632 9.73436C4.9887 9.97944 4.88936 10.4761 5.13444 10.8438C5.37953 11.2114 5.87622 11.3107 6.24384 11.0656L5.35632 9.73436ZM8.20008 8.8L9.00008 8.8C9.00008 8.50496 8.8377 8.23388 8.57757 8.09466C8.31744 7.95545 8.00181 7.9707 7.75632 8.13436L8.20008 8.8ZM7.40008 15.2C7.40008 15.6418 7.75826 16 8.20008 16C8.64191 16 9.00008 15.6418 9.00008 15.2L7.40008 15.2ZM6.24384 11.0656L8.64384 9.46564L7.75632 8.13436L5.35632 9.73436L6.24384 11.0656ZM7.40008 8.8L7.40008 15.2L9.00008 15.2L9.00008 8.8L7.40008 8.8Z" fill="currentColor" fillRule="nonzero" />
          </g>
          <g>
            <path d="M14.3563 9.73436C13.9887 9.97944 13.8894 10.4761 14.1344 10.8438C14.3795 11.2114 14.8762 11.3107 15.2438 11.0656L14.3563 9.73436ZM17.2001 8.8L18.0001 8.8C18.0001 8.50496 17.8377 8.23388 17.5776 8.09466C17.3174 7.95545 17.0018 7.9707 16.7563 8.13436L17.2001 8.8ZM16.4001 15.2C16.4001 15.6418 16.7583 16 17.2001 16C17.6419 16 18.0001 15.6418 18.0001 15.2L16.4001 15.2ZM15.2438 11.0656L17.6438 9.46564L16.7563 8.13436L14.3563 9.73436L15.2438 11.0656ZM16.4001 8.8L16.4001 15.2L18.0001 15.2L18.0001 8.8L16.4001 8.8Z" fill="currentColor" fillRule="nonzero" />
          </g>
        </g>
      </g>
    </svg>
  )
});